module.exports = __webpack_public_path__ + "img/bench-arrangement.a63112ff.webp";